// GENERATED by scripts/gen-hooks.mjs. Do not edit by hand.
// 4 hooks for backend/ownerLogins.

import { useBackend } from '../useBackend'

/** POST /api/ownerLogins/archiveOwnerLogin */
export function useArchiveOwnerLogin<T = any>() {
  return useBackend<T>('ownerLogins/archiveOwnerLogin')
}

/** POST /api/ownerLogins/getOwnerLogins */
export function useGetOwnerLogins<T = any>() {
  return useBackend<T>('ownerLogins/getOwnerLogins')
}

/** POST /api/ownerLogins/revealOwnerLogin */
export function useRevealOwnerLogin<T = any>() {
  return useBackend<T>('ownerLogins/revealOwnerLogin')
}

/** POST /api/ownerLogins/saveOwnerLogin */
export function useSaveOwnerLogin<T = any>() {
  return useBackend<T>('ownerLogins/saveOwnerLogin')
}
